<template>
  <div style="height: 100%;display: flex;flex-direction: row;">
    <HandlePlan @reload="detailKey++" style="width: 250px; height: unset; flex: unset;" @item-choose="item => chooseData = item" />
    <HandleDetail :key="detailKey" v-if="chooseData" :goodsHandleId="chooseData.id" style="flex: 1; width: 0;height: unset;margin-left: 0;padding: 0;" />
  </div>
</template>

<script>
import HandleDetail from './detail.vue'
import HandlePlan from '../../components/handle/plan.vue'

export default {
  components: { HandlePlan, HandleDetail },
  props: {},
  data () {
    return {
      chooseData: null,
      detailKey: 0
    }
  }
}
</script>
